import { render, staticRenderFns } from "./InformationCard.vue?vue&type=template&id=63f8a2b0&scoped=true"
import script from "./InformationCard.vue?vue&type=script&lang=js"
export * from "./InformationCard.vue?vue&type=script&lang=js"
import style0 from "./InformationCard.vue?vue&type=style&index=0&id=63f8a2b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f8a2b0",
  null
  
)

export default component.exports